import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {AbstractFilter} from './AbstractFilter';

export class BonusFilter extends AbstractFilter {
    protected bonus: number;

    constructor(name: string, bonus: number) {
        super(name);

        this.bonus = bonus;
    }

    public filter(response: Message, session: Session): boolean {
        if (response.getAction() === Action.SPIN || response.getAction() === Action.FREESPIN) {
            return this.getSpin(response).bonusId === this.bonus;
        }

        return true;
    }
}
